import React from 'react';
import { PanelTabs as PanelTabsNew } from './PanelTabs';
import { convertOldPanelTabsProps } from './converter.old';
import type { OldPanelTabsComponentProps, OldPanelTabsProps } from './converter.old';

export type PanelTabsProps = OldPanelTabsProps;
export type PanelTabsComponentProps = OldPanelTabsComponentProps;

export const PanelTabs: React.FC<PanelTabsComponentProps> = (props) => (
  <PanelTabsNew {...convertOldPanelTabsProps(props)} />
);
